import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { selectClient } from '../../actions/client';
import { evaluateCartPrice } from '../../actions/cart';
import { Client } from '../../services/typings';
import ClientSelector, { Props } from './ClientSelector';
import { State } from '../../reducers/typings';

function mapDispatchToProps(dispatch: Dispatch): Pick<Props, 'changeClient'> {
  return {
    changeClient(client: Client | null): void {
      dispatch(selectClient(client));
      // @ts-ignore missing cart actions typing yet
      dispatch(evaluateCartPrice());
    },
  };
}

function mapStateToProps(state: State): Pick<Props, 'selectedClient'> {
  return {
    selectedClient: state.client,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientSelector);
